module.exports = __webpack_public_path__ + "img/c996e8729f20e8374dc9ad52221bf2b8.52e8a7d2.png";